import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-40 bg-brand-beige border-t border-brand-border">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
          <div>
            <p className="eyebrow mb-6">(02) — What we do</p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease: [0.19, 1, 0.22, 1] }}
              className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-medium max-w-[18ch]"
            >
              Fifteen services. <span className="italic text-brand-brown">One studio.</span>
            </motion.h2>
          </div>
          <p className="max-w-md text-brand-charcoal/70 text-base md:text-lg leading-relaxed">
            Everything an ambitious modern brand needs — from the first campaign to the tenth. Pick one, or hand us the whole engine.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-border">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.7, delay: (i % 4) * 0.06, ease: [0.19, 1, 0.22, 1] }}
                className="group relative bg-white p-8 md:p-10 hover:bg-brand-brown/40 transition-colors duration-500 cursor-pointer"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-12 h-12 rounded-full bg-brand-gold/20 text-brand-gold group-hover:bg-brand-gold group-hover:text-brand-chocolate flex items-center justify-center transition-all duration-500">
                    <Icon size={20} strokeWidth={1.5} />
                  </div>
                  <ArrowUpRight
                    size={20}
                    className="text-brand-charcoal/30 group-hover:text-brand-brown group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500"
                  />
                </div>
                <h3 className="font-display text-2xl md:text-3xl leading-tight mb-3 font-medium">{s.title}</h3>
                <p className="text-sm text-brand-charcoal/70 leading-relaxed">{s.desc}</p>
                <span className="absolute bottom-0 left-0 right-0 h-px bg-brand-brown scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-700" />
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
